
const dateUtil = require('../dateUtil/dateUtil');
const stringUtil = require('../string/stringUtil');

var handledMessages = [];
module.exports.isMessageAlreadyHandled = function(messageId)
{
    deleteOldMessages();

    if (stringUtil.isStringNullOrEmpty(messageId))
        return false;

    if (handledMessages.find(m => m.id == messageId) != null)
        return true;

    var m = {};
    m.timestamp = dateUtil.getNow();
    m.id = messageId;

    handledMessages.push(m);
    return false;
}

function deleteOldMessages()
{
    var thresholdDate = dateUtil.getNow();
    thresholdDate = dateUtil.addMinutes(thresholdDate, -15);    
    handledMessages = handledMessages.filter(m => dateUtil.isSameOrAfter(m.timestamp, thresholdDate));
}
